import { css, sva } from "@agapi/ui/panda/css";
import { cva } from "@agapi/ui/panda/css";
export const navbarWrapperStyles = cva({
    base: {
        height: 'auto',
        display: 'flex',
        flexDirection: 'column',
        position: "fixed",
        top: "0",
        left: "0",
        right: "0",
        zIndex: 998,
        maxWidth: '100vw',
    },
    variants: {
        menuOpen: {
            true: {
                height: '100dvh',
            },
        },
    },
});
export const navbarStyles = sva({
    slots: ['root', 'row', 'group', 'brand', 'menubar'],
    base: {
        root: {
            width: '100%',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            zIndex: 12,
            position: "relative",
        },
        row: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '3',
            px: 'app',
            py: 2,
        },
        group: {
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
        },
        brand: {
            fontWeight: 'bold',
            fontSize: 'xl',
            textDecoration: 'none',
            '&:hover': {
                color: 'blue.700',
            },
        },
        menubar: {
            display: 'flex',
            gap: '1rem',
        },
    },
});
export const navbarItemStyles = sva({
    slots: ['root', 'label', 'icon'],
    base: {
        root: {
            cursor: 'pointer',
            textDecoration: 'none',
            display: 'flex',
            alignItems: 'center',
        },
        label: {
            gap: '3',
            textWrap: 'nowrap',
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'nowrap',
        },
        icon: {
            display: 'inline-flex',
            transition: 'transform 0.2s ease-in-out',
        },
    },
    variants: {
        open: {
            true: {
                icon: {
                    transform: 'rotate(180deg)',
                },
            },
        },
        active: {
            true: {
                label: {
                    fontWeight: 'bold',
                },
            },
        },
    },
});
export const megaMenuStyles = sva({
    slots: ['root', 'column', 'header', 'title', 'link'],
    base: {
        root: {
            position: 'fixed',
            top: 'var(--navbarHeight)',
            left: '0',
            width: '100%',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
            display: 'none',
            px: 'app',
            py: 5,
            zIndex: 9,
            maxWidth: "containers.2xl",
        },
        column: {
            flex: '1',
            display: 'flex',
            flexDirection: 'column',
            gap: '2',
            px: '3',
            pb: '5',
        },
        header: {
            pb: 2
        },
        title: {
            textStyle: 'h4',
        },
        link: {
            display: 'block',
            textDecoration: 'none',
            _hover: {
                color: 'primary.500',
            },
        },
    },
    variants: {
        open: {
            true: {
                root: {
                    display: 'grid',
                    gridTemplateColumns: {
                        base: 'repeat(2, 1fr)',
                        md: 'repeat(3, 1fr)',
                        lg: 'repeat(5, 1fr)',
                    },
                },
            },
        },
    },
});
export const backdropStyles = css({
    cursor: 'unset',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.33)',
    zIndex: 10,
});
export const drawerStyles = cva({
    base: {
        maxWidth: "calc(100vw - 3rem)",
        md: {
            maxWidth: "containers.sm",
        },
        scrollbarWidth: 'none',
        zIndex: 11,
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        flexShrink: 0,
        height: 'calc(100dvh - var(--navbarHeight))',
        minHeight: "calc(100dvh - var(--navbarHeight))",
        overflowY: 'scroll',
        marginLeft: 'auto',
        position: 'absolute',
        right: 0,
        top: 0,
        bottom: 0,
        left: 0,
    },
});
export const menuStyles = sva({
    slots: ['root', 'backdrop', 'group', 'item', 'submenu'],
    base: {
        root: {
            maxWidth: "calc(100vw - 3rem)",
            md: {
                maxWidth: "containers.sm",
            },
            scrollbarWidth: 'none',
            zIndex: 11,
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            flexShrink: 0,
            height: 'calc(100dvh - var(--navbarBottom))',
            minHeight: "calc(100dvh - var(--navbarBottom))",
            overflowY: 'scroll',
        },
        backdrop: {
            cursor: 'pointer',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.33)',
            zIndex: 10,
        },
        group: {
            display: 'flex',
            flexDirection: 'column',
        },
    },
});
export const menuItemStyles = sva({
    slots: ['root', 'label'],
    base: {
        root: {
            borderBottom: '1px solid',
            borderColor: 'rgba(0,0,0,0.099)',
            _expanded: {
                borderColor: 'rgba(0,0,0,0)',
            },
            _last: {
                borderColor: 'rgba(0,0,0,0)',
            },
        },
        label: {
            textStyle: 'body',
            fontSize: 'lg',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            px: 'app',
            py: '4',
            '& .caret': {
                transition: 'transform 0.2s ease-in-out',
            },
            "&[aria-haspopup='true']": {
                '& .caret': {
                    transform: 'rotate(90deg)',
                },
            },
            _expanded: {
                '& .caret': {
                    transform: 'rotate(-90deg)',
                },
            },
        },
    },
});
export const submenuStyles = cva({
    base: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'rgba(0,0,0,0.045)',
        boxShadow: 'inset 0 2px 8px -4px rgba(0,0,0,0.060)',
    },
});
export const menuToggleStyles = sva({
    slots: ['root', 'line'],
    base: {
        root: {
            width: 'token(fontSizes.2xl)',
            height: 'token(fontSizes.2xl)',
            minWidth: 'token(fontSizes.2xl)',
            minHeight: 'token(fontSizes.2xl)',
            cursor: 'pointer',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '2',
        },
        line: {
            transition: 'all 0.3s ease-in-out',
            display: 'block',
            height: 'token(spacing.1)',
            backgroundColor: 'currentColor',
            width: '100%',
            borderRadius: '9999px',
        },
    },
    variants: {
        open: {
            true: {
                line: {
                    opacity: 0,
                    width: 0,
                    _first: {
                        opacity: 1,
                        width: '100%',
                        transform: ' translateY(260%) rotate(45deg)',
                    },
                    _last: {
                        opacity: 1,
                        width: '100%',
                        transform: 'translateY(-260%) rotate(-45deg)',
                    },
                },
            },
        },
    },
});
export const searchStyles = sva({
    slots: ['form', 'input', 'inputRoot', 'button', 'overlay'],
    base: {
        form: {
            display: 'flex',
            alignItems: 'center',
        },
        inputRoot: {
            zIndex: 12
        },
        input: {
            width: '100%',
            height: '44px',
        },
        overlay: {
            position: 'fixed',
            top: 'var(--navbarHeight)',
            px: 'app',
            py: '4',
            left: 0,
            right: 0,
            zIndex: 10,
            maxHeight: 'calc(100dvh - var(--navbarHeight))',
            overflowY: 'scroll',
            scrollbarWidth: 'none',
        },
    },
});
export const navbarSkipStyles = css.raw({
    textStyle: 'body',
    fontWeight: 'bold',
    position: 'fixed',
    top: '0',
    left: '0',
    padding: '3',
    backgroundColor: 'surface.default.background',
    color: 'surface.default.foreground',
    zIndex: '9999',
    pointerEvents: 'none',
    '&:not(:focus)': {
        clip: 'rect(0, 0, 0, 0)',
        clipPath: 'inset(50%)',
        height: '1px',
        width: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: '0',
        whiteSpace: 'nowrap',
        position: 'absolute'
    },
    '&:focus': {
        clip: 'auto',
        clipPath: 'none',
        height: 'auto',
        width: 'auto',
        overflow: 'visible',
        pointerEvents: 'auto'
    }
});
